export const getCityPointById = (points, id) => points.find((item) => item.id === id);
export const getAdress = (item, cityName, notRenderPoint) => {
  if (!item) return null;
  const {
    street, house, room, entrance, floor, area, privateHouse,
  } = item;
  if (!street) return null;
  const adress = `${area ? `${area}, ` : ''}${street} ${house}${room ? `, квартира ${room}` : ''}${floor ? `, этаж ${floor}` : ''}${entrance ? `, подъезд ${entrance}` : ''}${privateHouse ? ' (частный дом)' : ''}`;
  const renderCity = !notRenderPoint && cityName && !adress.includes(cityName) ? `${cityName}, ` : '';
  return `${renderCity}${adress}`;
};
